module.exports = __webpack_public_path__ + "static/img/tavour-orange-black.b132367.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/tavour-orange-black.svg
// module id = 72
// module chunks = 1